// extracted by mini-css-extract-plugin
export default {"icon":"Breadcrumbs__icon--slots-ywhMc","title":"Breadcrumbs__title--slots-hew83"};